import * as React from "react";
import DocumentTitle from "react-document-title";
import Grid from "@material-ui/core/Grid";
import { observer } from "mobx-react-lite";
import { UserRoleEnum } from "../../static/enums/UserRole";
import { useGetUsers } from "../../helpers/hooks/useGetUsers";
import { uiStore } from "../../mobx/stores/UiStore/UiStore";
import { AssistantsProfilesTable } from "../../features/Tables/AssistantsProfilesTable/AssistantsProfilesTable";

export const AssistantsProfilesPage = observer(() => {
  const { loading } = uiStore;
  useGetUsers({
    role: UserRoleEnum.assistant,
  });

  return (
    <DocumentTitle title={"Помощники - Mindset.Digital"}>
      <Grid container spacing={3}>
        <AssistantsProfilesTable loading={loading} />
      </Grid>
    </DocumentTitle>
  );
});
